// src/components/Gantt/SkeletonGantt.tsx
import React from 'react';
import './SkeletonGantt.css';

const SkeletonRow: React.FC = () => (
  <tr>
    <td className="task_name_gantt">
      <div className="elements-content-gantt">
        <span className="square-animated-gantt" style={{ margin: '11px 0 0 35px' }}></span>
      </div>
      <div className="elements-content-gantt">
        <span className="square-animated-gantt" style={{ margin: '11px 0 0 8px' }}></span>
      </div>
      <div className="elements-content-gantt">
        <span className="spanthgantt" style={{ margin: '11px 0 0 55px' }}></span>
      </div>
    </td>
    <td className="task_start_gantt"></td>
    <td className="task_end_gantt"></td>
    <td className="task_est_gantt"></td>
    <td className="task_status_gantt"></td>
    <td className="task_week_gantt"></td>
    <td className="task_week_gantt"></td>
    <td className="task_week_gantt"></td>
    <td className="task_week_gantt"></td>
    <td className="task_week_gantt"></td>
  </tr>
);

const SkeletonGantt: React.FC = () =>
{
  const rows = Array.from({ length: 30 }, (_, i) => i);
  return (
    <table className="table-gantt">
      <tbody>
        {rows.map(i => (
          <SkeletonRow key={i} />
        ))}
      </tbody>
    </table>
  );
};

export default SkeletonGantt;
